import React from 'react';

import FindTemplate from '../components/common/template/FindTemplate';
import { useFindEmail, useFindPassword } from '../Hooks/useAuth';

const FindPage = () => {
  const {
    findEmailState,
    onFindEmail,
    onChangeFindEmailValue,
    findEmailRef,
    isFindEmailValidateTrue,
  } = useFindEmail();

  const {
    findPasswordState,
    onFindPassword,
    FindPasswordRef,
    onChangeFindPasswordValue,
    isFindPasswordValidateTrue,
  } = useFindPassword();

  return (
    <FindTemplate
      findEmailState={findEmailState}
      onFindEmail={onFindEmail}
      onChangeFindEmailValue={onChangeFindEmailValue}
      findEmailRef={findEmailRef}
      isFindEmailValidateTrue={isFindEmailValidateTrue}
      findPasswordState={findPasswordState}
      onFindPassword={onFindPassword}
      FindPasswordRef={FindPasswordRef}
      onChangeFindPasswordValue={onChangeFindPasswordValue}
      isFindPasswordValidateTrue={isFindPasswordValidateTrue}
    />
  );
};

export default FindPage;
